import { AfterViewInit, Component, OnInit ,
  ComponentRef,
    ViewContainerRef,
      ComponentFactoryResolver} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FollowLinkService } from '../../services/follow-link.service';
import { MapServicesService } from '../../../map/services/map-services.service';

import { Vehicle } from '../../models/interface';
// import { HistorialService } from '../../../historial/services/historial.service';
import { EventService } from 'src/app/events/services/event.service';
import { VehicleService } from '../../../vehicles/services/vehicle.service';
import { SliderMultimediaComponent } from 'src/app/shared/components/slider-multimedia/slider-multimedia.component';
import { DvrGalleryComponent } from 'src/app/events/components/dvr-gallery/dvr-gallery.component';
import { NgxSpinnerService } from 'ngx-spinner';


import * as L from 'leaflet';
import 'leaflet-polylinedecorator';

import * as moment from 'moment';
import Swal from 'sweetalert2';

import { forEach } from 'lodash';
// import { MapService } from '../../../services/map.service';


@Component({
  selector: 'app-follow-main',
  templateUrl: './follow-main.component.html',
  styleUrls: ['./follow-main.component.scss']
})
export class FollowMainComponent implements OnInit, AfterViewInit {

  logo:string = "assets/images/logo-gl-tracker-blue-dark.svg";
  id_seguimiento:string='';
/*   container:string='mapId01';
 */  unidades:Vehicle[]=[];
  config_seguimiento:any = {
    chk_mostrar_nota:false,
  }; //
  temporizadorUbicacion:any;

  availableOptionsUnidades = [{imei:'000000', nombre:'- - -'}];

  unidadSeleccionada:string = '000000';
  localizacionPanel = '...';
  estadoPanel = '...';

  VerNota = false;
  loadingHistorial: boolean = false;

  form:any = {};
  transfers = new Array();
  chkAllEvents: boolean = false;
  selectedEvents: any = [];


  private map :any;


  constructor(
      private route: ActivatedRoute,
      public followLinkService: FollowLinkService,
      public mapService: MapServicesService,
      // public historialService: HistorialService,
      private EventService: EventService,
      private VehicleService: VehicleService,
      private resolver: ComponentFactoryResolver,
      private container: ViewContainerRef,
      private spinner: NgxSpinnerService,

      // public historialService: HistorialService,
      
      // private mapService:MapService,
  ) { }

  private initMap(): void {
    this.map = L.map('map', {
      center: [ -10.730367, -75.691671 ],
      zoom: 5,
      zoomControl: true
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 20,
      minZoom: 3,
      attribution: '&copy; GL Tracker'
    });

    tiles.addTo(this.map);

    L.control.zoom({ position: 'topright' }).addTo(this.map);
  }
  
  ngOnInit(): void {
    console.log("========== ngOnInit =========");
  }

  limpiar_mapa() {
      //================= ELIMINAR HISTORIAL ====================
      var rdH = this.followLinkService.arrayRecorridos;
      for (let i = 0; i < rdH.length; i++) {
          var dH = rdH[i].recorrido;
          rdH[i].mostrarRuta = false;

          // var dH = this.historialService.tramasHistorial; // Data Historial
          this.mapService.map.removeLayer(dH[0].layer0);
          this.mapService.map.removeLayer(dH[dH.length - 1].layerN);
          this.mapService.map.removeLayer(dH[0].rutaH2);
          this.mapService.map.removeLayer(dH[0].rutaH2_trace);
          this.mapService.map.removeLayer(dH[0].ruta_sub);
          for (let i = 0; i < dH.length; i++) {
            if (dH[i].layer != null) {
              this.mapService.map.removeLayer(dH[i].layer);
            }
            if (dH[i]._trama_fecha_velocidad != null) {
              this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
            }
            this.mapService.map.removeLayer(dH[i]._trama);
          }

          //======= eventos ========
          var eH = rdH[i].eventos;
          for (let i = 0; i < eH.length; i++) {
            this.mapService.map.removeLayer(eH[i].layer);
          }
          //======= eventos ========
      }
      //================= ELIMINAR HISTORIAL FIN ===================
  }

  changeUnidad() {
    this.spinner.show('loadingHistorial');

    console.log("====== arrayRecorridos");
    
    console.log(this.followLinkService.arrayRecorridos);

    
    console.log("==> changeUnidad <==");
    console.log(this.unidadSeleccionada);
    this.mapService.map = this.map;

    let index = this.unidades.findIndex(x => x.imei === this.unidadSeleccionada);
    // console.log(index);
    if (index > -1) {

      console.log(this.unidades[index]);
      this.getReferencePanel(this.unidades[index]);
      
      // console.log(new Date());
      // console.log(this.unidades[index].fecha_tracker);

      var diffTime = moment( new Date() ).diff( new Date( this.unidades[index].fecha_tracker ) );
      var diffMin = (diffTime/(1000*60));
      this.estadoPanel = (diffMin < 10) ? ( (this.unidades[index].velocidad > 3)? 'MOVIMIENTO': 'PARADO') : ( (diffMin < 120) ? ( (this.unidades[index].velocidad > 3) ? 'SIN SEÑAL' : 'PARADO' ) : 'SIN TRANSMISIÓN' );

      // console.log(diffTime);
      // console.log(diffTime/(1000*60));// minutos
      // console.log(diffTime/(1000*60*60));// horas

      // console.log("velocidad -> ");
      // console.log(this.unidades[index].velocidad);
      
      // diffTime

      // $date = new Carbon( str_replace('-', '/',$request->fecha_actual) );
      // $minDiff = $date->diffInMinutes( new Carbon( $item->fecha_tracker ) );
      // $someObj->estado  =  ($minDiff < 10) ? ( ($item->velocidad > 3) ? 'MOVIMIENTO' : 'PARADO' ) : ( ($minDiff < 120) ? ( ($item->velocidad > 3) ? 'SIN SEÑAL' : 'PARADO' ) : 'SIN TRANSMISIÓN' )   ;
    


      let indexR = this.followLinkService.arrayRecorridos.findIndex(x => x.imei === this.unidadSeleccionada);

      if (indexR > -1) {
          console.log("LA UNIDAD LA EEXISTE - MOSTRAR HISTORIAL Y BORRAR LAS DEMAS");
          this.limpiar_mapa();

          this.spinner.hide('loadingHistorial');

          //================= MOSTRAR HISTORIAL ========================

          var historyUnidad = this.followLinkService.arrayRecorridos[indexR];

          var dH = historyUnidad.recorrido;
          var iH = dH[0].index_historial; //indices de paradas y movimientos

          dH[0].rutaH2.addTo(this.mapService.map); //Linea del historial
          // dH[0].ruta_sub.addTo(this.mapService.map); //Sub linea del historial
          dH[0].rutaH2_trace.addTo(this.mapService.map); 

          for (let j = 0; j < iH.length; j++) {
            if (dH[iH[j]].marker == 'PARADA') {
              // if (this.form.chckParada && rdH[i].mostrarRuta) {
              if (true) {
                dH[iH[j]].layer.addTo(this.mapService.map);
              } else {
                this.mapService.map.removeLayer(dH[iH[j]].layer);
              }
            }
          }

          var EventosAll = historyUnidad.eventos;
          console.log("====================== EventosAll cargar");
          console.log(EventosAll);
          for (let o = 0; o < EventosAll.length; o++) {
            EventosAll[o].layer.addTo(this.mapService.map);
          }
          
                     
          this.mapService.map.fitBounds(historyUnidad.min_max_lat_lng, {padding: [30, 30]});

          //================= MOSTRAR HISTORIAL FIN =========================

          
      } else {

          // calcular_historial 
          this.limpiar_mapa();

          if (this.config_seguimiento.chk_historial_ruta) {
            //parametros para sacar historial
            console.log("MOSTRAR HISTORIAL");
            
            var param = {
              fecha_desde: this.config_seguimiento.fecha_desde,
              fecha_hasta: this.config_seguimiento.fecha_hasta,
              vehiculos: JSON.stringify( [{imei:this.unidadSeleccionada}] ),
              user_id : this.config_seguimiento.id_usuario,
              follow : true
            };

            this.form.selectedCars = [{imei:this.unidadSeleccionada}]; 

            console.log(param);


            this.followLinkService.get_tramas_recorrido_varios_sin_permiso(param).then((res) => {


                this.spinner.hide('loadingHistorial');
                console.log('NO HAY SUFICIENTE INFORMACIÓN ' + this.followLinkService.tramasHistorial.length);
                if (this.followLinkService.tramasHistorial[0].length <=1) {
                    Swal.fire({
                      title: 'Error',
                      text: 'No hay suficiente información.',
                      icon: 'error',
                    });
                }


                // return this.http.post(url,params);
                console.log("===>> get_tramas_recorrido_varios");
                console.log( this.followLinkService.tramasHistorial );
                console.log(res);

                // this.EventService.ShowAllHistorial(param).then((res1) => {
                //   console.log("==> eventsHistorial");
                //   console.log( this.EventService.eventsHistorial );
                // });

                console.log("MOSTRAR EVENTO");
                console.log("TRUE");
                console.log(this.config_seguimiento.chk_historial_evento);
                console.log("FALSE");
                console.log(this.config_seguimiento.chk_historial_evento);
                // let servi = ['EventService', 'followLinkService'];
                // if (!this.config_seguimiento.chk_historial_evento) {
                //   servi = 'followLinkService';
                // }
                
                ((this.config_seguimiento.chk_historial_evento) ? ( this.EventService ):( this.followLinkService )).ShowAllHistorial(param).then((res1) => {

                console.log(this.EventService.eventsHistorial);
                  
                // this.EventService.ShowAllHistorial(param).then((res1) => {
          
                  // $result = array();
                  // foreach ($paramVehiculos as $pVehiculo) {
                  //     $array_unidad = array();
                  //     for ($i=0; $i < count($event) ; $i++) {
                  //         if ($event[$i]->imei == $pVehiculo->imei) {
                  //             $array_unidad[] = $event[$i];
                  //         }
                  //     }
                  //     $result[] = $array_unidad;
                  // }
          
                  var eventosAll = new Array();
                  for (let index = 0; index < this.form.selectedCars.length; index++) {
                    const unidadOne = this.form.selectedCars[index];
                    var array_unidad = new Array();
                    for (let index = 0; index < this.EventService.eventsHistorial.length; index++) {
          
                      // this.EventService.eventsHistorial[index].layer.on('click', (e:any) => {
                      //   this.getReference(this.EventService.eventsHistorial[index]);
                      //   console.log("----- row - icono - EVENTOSX ----");
                      //   // if (mostrarRuta) {
                      //   console.log(this.EventService.eventsHistorial[index]);
                      //   console.log(e);
                      //   // this.clearMultimedia(this.EventService.eventsHistorial[index]);
                      //   // this.EventService.eventsHistorial[index].layer.openPopup();
                      //   // this.addMultimediaComponent(this.EventService.eventsHistorial[index]);
                      //   // }
                      //   // this.mapService.map.setView([trama.lat, trama.lng], 15);
                      // });
          
          
                      const eventoOne = this.EventService.eventsHistorial[index];
                      if (eventoOne.imei == unidadOne.imei) {
                        array_unidad.push(eventoOne);
                      }
                    }
                    eventosAll.push(array_unidad);
                  }
          
          
                  console.log("===========================");
                  console.log(res);
                  // console.log(this.historialService.tramasHistorial);
                  console.log("===========================EVENTOOSSS=====");
                  console.log(res1);
                  console.log(this.EventService.eventsHistorial);
                  console.log(eventosAll);
          
                  // this.spinner.hide('loadingHistorial');
          
                  var minLat = 0; //parseFloat(dH[0].lat);
                  var maxLat = -90; //parseFloat(dH[0].lat);
                  var minLng = 0; //parseFloat(dH[0].lng);
                  var maxLng = -180; //parseFloat(dH[0].lng);
          
                  var strVacio = "";
          
                  for (let indexx = 0; indexx < this.followLinkService.tramasHistorial.length; indexx++) {
                    // console.log("=========================");
                    // console.log(indexx);
          
                    const duracion = 60;//parseInt(this.form.duracionParada);
                    var dH = this.followLinkService.tramasHistorial[indexx]; //this.historialService.tramasHistorial; // Data Historial
                    var index_historial2 = new Array();
                    console.log(dH);
          
                    if (dH.length > 1) {
          
                      var nombreUnidad = this.unidades[index].nombre;
                      var icono = this.unidades[index].icon;
                      // var nameoperation = this.unidades[index].icon;
                      var imei =  this.unidades[index].imei;
                      // var nombreUnidad = this.form.selectedCars.filter((item: any) => item.imei == dH[0].imei)[0].nombre;
                      // var icono = this.form.selectedCars.filter((item: any) => item.imei == dH[0].imei)[0].icon;
                      // var nameoperation = this.form.selectedCars.filter((item: any) => item.imei == dH[0].imei)[0].nameoperation;
                      // var imei = dH[0].imei;
          
                      console.log(nombreUnidad+" -- "+icono+" -- "+'nameoperation');
          
                      var evHistorial = [];
                      for (let j = 0; j < eventosAll.length; j++) {
                        if (eventosAll[j].length > 0) {
                          if (eventosAll[j][0].imei == dH[0].imei) {
                            evHistorial = eventosAll[j];
                          }
                        }
                      }
          
          
                      // this.conHistorial = true; // tenemos historial con datod
                      var d = 0;
                      var k = [];
                      var l = new Array();
                      k.length = 0;
                      l.length = 0;
                      var o = 0;
                      const h = dH.length - 1; //Ultimo indice del array
                      // var minLat = parseFloat(dH[0].lat);
                      // var maxLat = parseFloat(dH[0].lat);
                      // var minLng = parseFloat(dH[0].lng);
                      // var maxLng = parseFloat(dH[0].lng);
                      dH[0].rutaH = [];
                      dH[0].primero = h; // guardar el numero de elementos en la primera trama.
                      dH[0].nombre = nombreUnidad; //this.nombreUnidad; //"Nombre Unidad";//param.nombreUnidad;
                      // (dH[0].imei = this.imei = this.form.selectedCar), (dH[h].ultimo = h); // guardar el numero de elementos en la ultima trama.
                      dH[h].nombre = nombreUnidad; //this.nombreUnidad; //"Nombre Unidad";//param.nombreUnidad;
          
          
                      for (let i = 0; i < dH.length; i++) {
                        if (i != 0) {
                          dH[i].distancia =
                            this.calcularDistanciaEntreDosCoordenadas(
                              dH[i - 1].lat,
                              dH[i - 1].lng,
                              dH[i].lat,
                              dH[i].lng
                            ) * 1000;
                        }
                        dH[i].dt_ss = new Date(dH[i].dt_server);
                        dH[i].dt_js = new Date(dH[i].dt_tracker);
                        dH[i].dt_tracker = dH[i].dt_tracker.replace(/\//g, '-');
                        dH[i].lat = parseFloat(dH[i].lat);
                        dH[i].lng = parseFloat(dH[i].lng);
                        dH[i].paramsGet = this.getParams(dH[i].params);
                        dH[i]._trama = this.get_trama_marker(dH[i]); //.addTo(this.mapService.map); 
                        dH[i]._trama_fecha_velocidad = this.get_trama_marker_fecha_velocidad(dH[i]); //.addTo(this.mapService.map);
                        var arrayP = [];
                        dH[0].rutaH.push([dH[i].lat, dH[i].lng]); // guardar puntos para dibujar la linea del recorrido
                        if (dH[i].lat < minLat) {
                          minLat = dH[i].lat;
                        }
                        if (dH[i].lat > maxLat) {
                          maxLat = dH[i].lat;
                        }
                        if (dH[i].lng < minLng) {
                          minLng = dH[i].lng;
                        }
                        if (dH[i].lng > maxLng) {
                          maxLng = dH[i].lng;
                        }
                        dH[i].historial2 = 0;
                        dH[i].indice = i;
                        if (dH[i].speed <= 3) {
                          if (i == h) {
                            if (l.length == 0) {
                              //estado = 0;
                              var p = dH[0].dt_js;
                              var q = dH[h].dt_js;
                              var r = this.string_diffechas(p, q);
                              dH[0].historial2 = 1;
                              dH[0].estado = 0;
                              dH[0].temp = r;
                              dH[0].marker = 'PARADA';
                              index_historial2[d] = 0;
                              d++;
                            } else if (l.length > 0 && k.length > 0) {
                              var p = dH[k[0]].dt_js;
                              var q = dH[i].dt_js;
                              var s = Math.floor((q - p) / 1000);
                              if (s > duracion) {
                                //estado = 1;
                                var p = dH[l[0]].dt_js;
                                var q = dH[k[0]].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                                //estado = 0;
                                var p = dH[k[0]].dt_js;
                                var q = dH[i].dt_js;
                                var t = this.string_diffechas(p, q);
                                dH[k[0]].historial2 = 1;
                                dH[k[0]].estado = 0;
                                dH[k[0]].temp = t;
                                dH[k[0]].marker = 'PARADA'; //marker_x("images/stop.png", [dH[k[0]].lat, dH[k[0]].lng], [7, 26], k[0]);
                                index_historial2[d] = k[0];
                                d++;
                                l.length = 0;
                                k.length = 0;
                              } else {
                                var p = dH[l[0]].dt_js;
                                var q = dH[i].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                              }
                            } else if (l.length > 0 && k.length == 0) {
                              if (l.length >= 1) {
                                var p = dH[l[0]].dt_js;
                                var q = dH[i].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                              }
                            }
                          }
                          k.push(i);
                        } else {
                          if (k.length > 0) {
                            var p = dH[k[0]].dt_js;
                            var q = dH[i].dt_js;
                            var t = this.string_diffechas(p, q);
                            var s = Math.floor((q - p) / 1000);
                            if (s > duracion) {
                              if (o == 1) {
                                var p = dH[l[0]].dt_js;
                                var q = dH[k[0]].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                                dH[k[0]].historial2 = 1;
                                dH[k[0]].estado = 0;
                                dH[k[0]].temp = t;
                                dH[k[0]].marker = 'PARADA'; //marker_x("images/stop.png", [dH[k[0]].lat, dH[k[0]].lng], [7, 26], k[0]);
                                index_historial2[d] = k[0];
                                d++;
                                l.length = 0;
                                k.length = 0;
                              }
                              if (l.length > 0 && dH[l[0]].dt_tracker == dH[0].dt_tracker) {
                                //estado = 1;
                                var p = dH[l[0]].dt_js;
                                var q = dH[k[0]].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                                //estado = 0;
                                dH[k[0]].historial2 = 1;
                                dH[k[0]].estado = 0;
                                dH[k[0]].temp = t;
                                dH[k[0]].marker = 'PARADA'; //marker_x("images/stop.png", [dH[k[0]].lat, dH[k[0]].lng],  [7, 26], k[0]);
          
                                index_historial2[d] = k[0];
                                d++;
                                l.length = 0;
                                k.length = 0;
                                o = 1;
                              }
                              if (k.length > 0 && dH[k[0]].dt_tracker == dH[0].dt_tracker) {
                                dH[k[0]].historial2 = 1;
                                dH[k[0]].estado = 0;
                                dH[k[0]].temp = t;
                                dH[k[0]].marker = 'PARADA'; //marker_x("images/stop.png" , [dH[k[0]].lat, dH[k[0]].lng],  [7, 26], k[0]);
                                index_historial2[d] = k[0];
                                d++;
                                k.length = 0;
                                o = 1;
                              }
                            } else {
                              var u = l.concat(k);
                              k.length = 0;
                              l.length = 0;
                              l = u;
                              if (i == h) {
                                var p = dH[l[0]].dt_js;
                                var q = dH[i].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                              }
                            }
                          } else {
                            if (i == h) {
                              if (l.length == 0) {
                                var p = dH[0].dt_js;
                                var q = dH[h].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[0].historial2 = 1;
                                dH[0].estado = 1;
                                dH[0].temp = r;
                                index_historial2[d] = 0;
                                d++;
                              } else if (l.length > 0) {
                                var p = dH[l[0]].dt_js;
                                var q = dH[i].dt_js;
                                var r = this.string_diffechas(p, q);
                                dH[l[0]].historial2 = 1;
                                dH[l[0]].estado = 1;
                                dH[l[0]].temp = r;
                                index_historial2[d] = l[0];
                                d++;
                              }
                            }
                          }
                          l.push(i);
                          // console.log("========== variable l =========");
                          // console.log(l);
                        }
                      } //el for termina aqui
          
                      var count = 1;
                      console.log("============== index_historial2 ===============");
                      console.log(index_historial2);
                      
                      index_historial2.forEach((item, i) => {
                        if (dH[item].marker == 'PARADA') {
                          console.log("====== PARADA =======");
                          
                          if (i != index_historial2.length - 1) {
                            dH[item].paradaFin = dH[index_historial2[i + 1]].dt_tracker;
                          } else {
                            dH[item].paradaFin = dH[dH.length - 1].dt_tracker;
                          }
                          dH[item].count = count++;
                          dH[item].nombre = nombreUnidad; //this.nombreUnidad; //"Nombre Unidad";//param.nombreUnidad;
                          dH[item].layer = this.get_parada_marker(dH[item]).addTo(this.mapService.map);
                          // if (this.form.chckParada) {
                          // if (true) {
                          //   dH[item].layer.addTo(this.mapService.map);
                          // }
                        } else {
                          dH[item].marker = 'MOVIMIENTO';
                          let a1, a2; //Primer y ultimo punto de una sublinea
                          if (i == 0) {
                            a1 = 0;
                            if (index_historial2.length == 1) {
                              a2 = dH.length - 1;
                            } else {
                              a2 = index_historial2[i + 1];
                            }
                          } else if (i == index_historial2.length - 1) {
                            a1 = index_historial2[i - 1];
                            a2 = dH.length - 1;
                          } else {
                            a1 = index_historial2[i - 1];
                            a2 = index_historial2[i + 1];
                          }
                          dH[item].cc = [a1, a2];
                          dH[item].combustible_movimiento = this.get_combustible_movimiento(
                            dH,
                            a1,
                            a2
                          );
                          dH[item].distancia_movimiento = this.get_distancia_movimiento(
                            dH,
                            a1,
                            a2
                          );
                        }
                      });
          
                      dH[0].index_historial = index_historial2;
                      dH[0].layer0 = this.get_inicial_marker(dH[0]).addTo(this.mapService.map);
                      dH[h].layerN = this.get_final_marker(dH[h]).addTo(this.mapService.map);


                      var min_max_lat_lng:any = [
                        [minLat, minLng],
                        [maxLat, maxLng],
                      ];
                      this.mapService.map.fitBounds(min_max_lat_lng, {padding: [30, 30]});


          
                      var color = 'red'; //this.form.colorHistorial; //'red';
                      // if (this.followLinkService.tramasHistorial.length == 1) {
                      //     color = this.form.colorHistorial; //'red';
                      // } else {
                      //     color = 'red'; //this.colorArray[this.followLinkService.colorArrayIndex++]; // 'red'; //this.form.colorHistorial; //'red';
                      // }
          
                      var color_sub = 'blue';

                      console.log("==== PAT DEL HISTORIAL");
                      console.log(dH[0].rutaH);
                      
                      
                      dH[0].rutaH2 = this.get_historial_line(dH[0].rutaH, color).addTo(this.mapService.map); //Linea del historial
                      dH[0].ruta_sub = this.get_historial_line([], color_sub).addTo(this.mapService.map); //Sub linea del historial
          
                      // Crea el decorador de línea
                      dH[0].rutaH2_trace = L.polylineDecorator(dH[0].rutaH, {
                        patterns: [
                          {
                            offset: 0,
                            repeat: 30,
                            symbol: L.Symbol.arrowHead({
                              pixelSize: 4.3,
                              polygon: false,
                              pathOptions: {
                                stroke: true,
                                weight: 1.4,
                                color: 'black',
                                opacity: 1,
                              },
                            }),
                          },
                        ],
                      }).addTo(this.mapService.map);
          
                      // Función para animar las flechas
                      let currentOffset = 0;
                      function animateArrows() {
                        currentOffset += 0.2;
                        if (currentOffset > 35) {
                          currentOffset = 0;
                        }
          
                        // Actualiza el offset de la flecha
                        dH[0].rutaH2_trace.setPatterns([
                          {
                            offset: currentOffset,
                            repeat: 35,
                            symbol: L.Symbol.arrowHead({
                              pixelSize: 5,
                              polygon: false,
                              pathOptions: {
                                stroke: true,
                                weight: 3,
                                color: color,
                                opacity: 1,
                              },
                            }),
                          },
                        ]);
          
                        requestAnimationFrame(animateArrows);
                      }
                      animateArrows();
          
          
          
          
                      var combustibleTotal = this.get_combustible_movimiento(dH, 0, 'FIN'); //'100 gal.';
                      var kilometrajeTotal = this.get_distancia_movimiento(dH, 0, 'FIN'); //'100 gal.';
          
                      console.log('dH', dH);
          
                      // var unidad = this.VehicleService.getVehiclesData().filter( (item: any) => item.IMEI == imei )[0];
          
                          // let MHstr = '' + moment(this.form.pngFechaFin).format('M');
                          // let DHstr = '' + moment(this.form.pngFechaFin).format('D');
                          // let HMHstr = '' + moment(this.form.pngHoraFin2).format('HH:mm:00');
                      
                          // var M1 =
                          //   moment(this.form.pngFechaIni).format('YYYY') +
                          //   '-' +
                          //   this.fStrMD(MDstr) +
                          //   '-' +
                          //   this.fStrMD(DDstr) +
                          //   'T' +
                          //   HMDstr +
                          //   '-05:00';


                          // {{ config_seguimiento.fecha_desde | date:'yyyy-MM-dd HH:mm:ss' }} - {{ config_seguimiento.fecha_hasta | date:'yyyy-MM-dd HH:mm:ss' }}

                      var M1 = this.config_seguimiento.fecha_desde;
                      var M2 = this.config_seguimiento.fecha_desde;
                      var M1str = this.config_seguimiento.fecha_desde;
                      var M2str = this.config_seguimiento.fecha_hasta;

                      this.followLinkService.arrayRecorridos.push({
                        key: nombreUnidad + '_' + M1 + '_' + M2, //this.nombreUnidad + '_' + M1 + '_' + M2,
                        // unidad: unidad,
                        imei:imei,
                        icono: icono,
                        nameoperation: '',//nameoperation,
                        nombre: nombreUnidad,//this.nombreUnidad,
                        f_ini: M1str,
                        f_fin: M2str,
                        kilometrajeTotal: kilometrajeTotal,
                        combustibleTotal: combustibleTotal,
                        mostrarRuta: true,
                        recorrido: dH,
                        eventos: evHistorial, //this.EventService.eventsHistorial,
                        tramas: [],
                        min_max_lat_lng: min_max_lat_lng,
                      });
          
                      //==============================================

                     
                      //==> los eventos se cargaran 1s. despues
                      setTimeout(() => {
                        this.mostrar_eventos_by_key(this.followLinkService.arrayRecorridos.length - 1);
                      }, 1000);

                      
                      //------FALTA
                      this.mostrar_tabla2(
                        dH,
                        dH[0].index_historial,
                        this.followLinkService.arrayRecorridos.length - 1
                      );
          
                      this.changeShowingTramas();
                      //this.changeShowingGrafico();
                      this.changeShowingTramasFechaVelocidad();
                      // this.isHistorialTableLoaded = true;
          
                    } else {
                      // this.spinner.hide('loadingHistorial');
          
                      console.log('========NO HAY SUFICIENTE INFORMACIÓN');
                      console.log(this.form.selectedCars[indexx].nombre);
          
                      if (strVacio == "") {
                        strVacio = strVacio +"<b>"+this.form.selectedCars[indexx].nombre+"</b>"
                      } else {
                        strVacio = strVacio +",<br> <b>"+this.form.selectedCars[indexx].nombre+"</b>"
                      }
          
                      // Swal.fire({
                      //   title: 'Error',
                      //   text: 'No hay suficiente información.',
                      //   icon: 'error',
                      // });
                    }
                  }
          
                  if (strVacio != "") {
                    // Swal.fire({
                    //   title: 'Unidades sin recorrido :',
                    //   html: '' + strVacio,
                    //   // text: 'Unidades sin recorrido : '+strVacio,
                    //   icon: 'warning',
                    // });
                  }
          
                }).catch((error)=>{
                    console.error(error);
                    console.log('panel historial: event service error',error);
                }); // fin de consulta de eventos


            }).catch((error)=>{
                console.error(error);
                // const errorFlag: Record<number,string>={
                //   422:'Inconsistencias detectadas en los datos ingresados. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.',
                //   500:'Ha ocurrido un problema al intentar procesar su solicitud. Por favor, inténtelo de nuevo más tarde. Si el problema persiste, póngase en contacto con el área de TI.',
                // }
          
            }); // fin de historial tramas



          } else {
            // mostrar la ubicacion de la unidad

            // var min_max_lat_lng:any = [
            //   [minLat, minLng],
            //   [maxLat, maxLng],
            // ];
            // this.mapService.map.fitBounds(min_max_lat_lng, {padding: [30, 30]});


            // this.mapService.map.fitBounds(historyUnidad.min_max_lat_lng, {padding: [30, 30]});
            let index = this.unidades.findIndex(x => x.imei === this.unidadSeleccionada);
            // console.log(index);
            if (index > -1) {
              
              console.log(" --- ubicacion --- ");
              console.log(this.unidades[index]);
              this.mapService.map.setView([this.unidades[index].latitud, this.unidades[index].longitud], 13);

            }

          }
          if (this.config_seguimiento.chk_historial_evento) {
              console.log("MOSTRAR HISTORIAL DE EVENTOS");
          }
        
      }

      

      if (this.config_seguimiento.chk_mostrar_nota) {
          console.log("MOSTRAR NOTA");
      }
      if (this.config_seguimiento.chk_multiples_unidades) {
          console.log("MOSTRAR MULTIPLES UNIDADES");
      }

    } else {
      this.localizacionPanel = '...';
      this.estadoPanel = '...';

    }    

  }


  //============ MOSTRAR EVENTOS =====================
  mostrar_eventos_by_key(i:number) {
    var historyUnidad = this.followLinkService.arrayRecorridos[i];
    // var dH = historyUnidad.recorrido;
    var EventosAll = historyUnidad.eventos;
    for (let o = 0; o < EventosAll.length; o++) {
      // console.log(o);
      EventosAll[o].layer.addTo(this.mapService.map);
      EventosAll[o].layer.on('click', (e:any) => {
        console.log("CLICK EN EVENTO");
        console.log(e);
        console.log(this.followLinkService.arrayRecorridos[i]);
        console.log(this.followLinkService.arrayRecorridos[i].eventos);
        console.log(this.followLinkService.arrayRecorridos[i].eventos[o]);

        this.clearMultimedia(this.followLinkService.arrayRecorridos[i].eventos[o]);
        this.followLinkService.arrayRecorridos[i].eventos[o].layer.openPopup();
        this.addMultimediaComponent(this.followLinkService.arrayRecorridos[i].eventos[o]);
        this.addDVRGalleryComponent(this.followLinkService.arrayRecorridos[i].eventos[o]);
      });

    }
  }
  //============ MOSTRAR EVENTOS FIN =====================
  
  clickZoomHistorial(i:number){
    console.log("=================");
    
    console.log(i);
    
    var historyUnidad = this.followLinkService.arrayRecorridos[i];
    this.mapService.map.fitBounds(historyUnidad.min_max_lat_lng, {padding: [30, 30]});
  }
  

  clickLocate(row: any, key: any = -1, rowIndex:any) {
    console.log("========================= x");
    console.log(row);
    console.log(key);
    console.log(rowIndex);

    console.log("rowIndex : " + row.index_master);
    
    
    
        
    // this.waitTimeServices.startTime({
    //   id: row.trama.uuid_event,
    //   start: Date.now(),
    //   itemsId: [],
    //   end: [],
    //   event: [],
    //   type: [],
    //   size: [],
    //   duration: []
    // });
    console.log('=======  clickLocate =========');
    console.log('VERIFICACION DE LAS ROW -> ', row);
    console.log(key);
    console.log('fila de datos ', row);

    console.log("Conseguir solo su URL de ICONO" ,row.icono)
    var mostrarRuta = false;

    //=======================================================================================
    var ri  = row.index_master;
    var rdH = this.followLinkService.arrayRecorridos;
    var dH = rdH[ri].recorrido;
    var mostrarRuta = rdH[ri].mostrarRuta;

    // for (let i = 0; i < rdH.length; i++) {
    //   //console.log(rdH[i].key+"  -  -  "+key);
    //   if (rdH[i].key == key) {
    //     var dH = rdH[i].recorrido;
    //     mostrarRuta = rdH[i].mostrarRuta;
    //   }
    // }
    //=======================================================================================
  

    let trama = row.trama;
    // console.log("VERIFICACION DE LAS");
    // console.log(trama);

    /* const iconUrl = getIconUrlHistory(row.icono); */

    // this.clearMultimedia(trama);
    // this.addMultimediaComponent(trama);

    // if (row.icono) {
    //   console.log("----- row - icono ----");
    //   this.clearMultimedia(trama);
    //   trama.layer.openPopup();
    //   this.addMultimediaComponent(trama);
    //   this.mapService.map.setView([trama.lat, trama.lng], 15);
    // } else
    // if (row.icono == 'assets/images/start.png') {
    if (row.icono == 'assets/images/route_start.png') {
      // console.log("--primero ----");
      trama.layer0.fireEvent('click');
      this.mapService.map.setView([trama.lat, trama.lng], 15);
    } else if (row.icono == 'assets/images/end.png') {
      // console.log("--ultimo ----");
      trama.layerN.fireEvent('click');
      this.mapService.map.setView([trama.lat, trama.lng], 15);
    } else if (row.icono == 'assets/images/stop.svg') {
      // console.log("-----parada ----");
      trama.layer.fireEvent('click');
      this.mapService.map.setView([trama.lat, trama.lng], 15);
    } else if (row.icono == 'assets/images/drive.svg') {
      // console.log("-----movimiento ----");

      // var rdH = this.historialService.arrayRecorridos;

      // for (let i = 0; i < rdH.length; i++) {

      //     var dH = rdH[i].recorrido;
      //     var iH  = dH[0].index_historial; //indices de paradas y movimientos

      //     this.mostrar_tabla2(dH,iH,i);

      //     for (let i = 0; i < iH.length; i++) {
      //       if (dH[iH[i]].marker == "PARADA") {
      //         if (this.form.chckParada ) {
      //           dH[iH[i]].layer.addTo(this.mapService.map);
      //         } else {
      //           this.mapService.map.removeLayer(dH[iH[i]].layer);
      //         }
      //       }
      //     }
      // }

      //console.log("-----movimiento ----");

      let t1 = trama.cc[0];
      let t2 = trama.cc[1];
      let cc = [];

      let minLat = dH[t1].lat;
      let maxLat = dH[t1].lat;
      let minLng = dH[t1].lng;
      let maxLng = dH[t1].lng;

      for (let i = t1; i <= t2; i++) {
        cc.push([dH[i].lat, dH[i].lng]);

        if (dH[i].lat < minLat) {
          minLat = dH[i].lat;
        }
        if (dH[i].lat > maxLat) {
          maxLat = dH[i].lat;
        }
        if (dH[i].lng < minLng) {
          minLng = dH[i].lng;
        }
        if (dH[i].lng > maxLng) {
          maxLng = dH[i].lng;
        }
      }

      //this.mapService.map.fitBounds(cc, { padding: [30, 30] });
      this.mapService.map.fitBounds(
        [
          [minLat, minLng],
          [maxLat, maxLng],
        ],
        { padding: [30, 30] }
      );
      // console.log("log ==> cc");
      // console.log(cc);
      // console.log(dH[0].ruta_sub);
      dH[0].ruta_sub.setLatLngs(cc); //.addTo(this.mapService.map);
      dH[0].ruta_sub.setStyle({ opacity: 1, color: 'blue' });
    } else {
      console.log("----- row - icono - EVENTOSX ----");
      // if (mostrarRuta) {
      this.clearMultimedia(trama);
      trama.layer.openPopup();
      this.addMultimediaComponent(trama);
      this.addDVRGalleryComponent(trama);
      // }
      this.mapService.map.setView([trama.lat, trama.lng], 15);
    }
  }


  async ngAfterViewInit() {

    console.log("================ XD 1 ==================");
    this.initMap();
    console.log("================ XD 2 ==================");

    // // Obtiene el parámetro configId de la URL
    // // await this.createMap();

    // // var map = L.map('mapId01').setView([51.505, -0.09], 13);

    this.route.params.subscribe(params => {
      console.log("===== PARAMETROS =====");
      console.log(params);
      // this.id_seguimiento = params['id_seguimiento'];

      this.followLinkService.getDataSeguimiento(params).subscribe(response => {
        console.log("===== RESULTADO =====");
        console.log(response);

        var result:any = response;
        this.config_seguimiento = result.seguimiento[0];
        this.unidades = result.userTrackers;

  

        console.log(this.unidades);
        for (let i = 0; i < this.unidades.length; i++) {
          this.availableOptionsUnidades.push({imei:this.unidades[i].imei ,nombre:this.unidades[i].nombre  });    
          this.VehicleService.vehicles.push({IMEI:this.unidades[i].imei ,name:this.unidades[i].nombre });     
        }


        var minLat = 0; //parseFloat(dH[0].lat);
        var maxLat = -90; //parseFloat(dH[0].lat);
        var minLng = 0; //parseFloat(dH[0].lng);
        var maxLng = -180; //parseFloat(dH[0].lng);

        for (let i = 0; i < this.unidades.length; i++) {

          var unidad:any = this.unidades[i];

          this.unidades[i].latitud  = parseFloat(unidad.latitud);
          this.unidades[i].longitud = parseFloat(unidad.longitud);

          if (this.unidades[i].latitud  < minLat) {
            minLat = this.unidades[i].latitud ;
          }
          if (this.unidades[i].latitud  > maxLat) {
            maxLat = this.unidades[i].latitud ;
          }
          if (this.unidades[i].longitud < minLng) {
            minLng = this.unidades[i].longitud;
          }
          if (this.unidades[i].longitud > maxLng) {
            maxLng = this.unidades[i].longitud;
          }

          //{lat:0,lng:0} ,
          // this.unidades[i].path_cola = [ { lat: this.unidades[i].latitud, lng:this.unidades[i].longitud }  ];

          //[0,0]
          // this.unidades[i].rutaH = [];
          // this.unidades[i].rutaH.push([this.unidades[i].latitud, this.unidades[i].longitud]);

          this.unidades[i].latitud_anterior  = parseFloat(unidad.latitud);
          this.unidades[i].longitud_anterior = parseFloat(unidad.longitud);

          let icon_svg = this.unidades[i].icon.split('/').pop();
          
          this.unidades[i].icono = L.marker([0, 0],
            { icon: L.icon({
                iconUrl: './assets/images/objects/nuevo/backup/'+icon_svg,
                iconSize: [54, 54],
                iconAnchor: [27, 27]
            }),
            //clickable: true
          }).bindPopup( i+'', {offset: new L.Point(0, -16)} );

          this.unidades[i].icono.setLatLng([unidad.latitud, unidad.longitud])
          this.unidades[i].icono.addTo(this.map);

          this.unidades[i].tooltip = this.get_tooltip(unidad).addTo(this.map);
          this.unidades[i].icono.setPopupContent( this.getContentSimu(unidad) );

          var opciones = {
            color: '#00d425',
            weight: 3,
            opacity: 1.0,
          };

          // var rutaH = [];
          // rutaH.push([dH[i].lat, dH[i].lng]); // guardar puntos para dibujar la linea del recorrido

          this.unidades[i].polyline_cola = L.polyline( [{lat:this.unidades[i].latitud, lng:this.unidades[i].longitud}], opciones).addTo(this.map);
          // this.unidades[i].polyline_cola_trace = L.polylineDecorator( this.unidades[i].polyline_cola , {
          this.unidades[i].polyline_cola_trace = L.polylineDecorator( this.unidades[i].rutaH , {

            patterns: [
              {
                offset: 0,
                repeat: 20,
                symbol: L.Symbol.arrowHead({
                  pixelSize: 7,
                  polygon: true,
                  pathOptions: {
                    stroke: true,
                    weight: 1,

                    color: '#00d425',
                    opacity: 1,

                    fillColor: 'white',
                    fillOpacity : 1,
                  },
                }),
              },
            ],
          }).addTo(this.map);


          //this.decoradorMASTER(this.unidades[i]);
         


           // CENTRAR UNIDADES EN EL MAPA
           


          this.unidades[i].icono.on('click', (e:any) => {
            this.getReference(this.unidades[i]);
          });


            // <div class="gl-row-underline">
            //   <div class="col-12">
            //     <label>FILTRAR POR:</label>
            //   </div>
            //   <div class="col-12">
            //     <p-dropdown
            //       [options]="availableOptionsDay"
            //       optionLabel="name"
            //       optionValue="id"
            //       [(ngModel)]="form.selectedRango"
            //       [showClear]="false"
            //       [appendTo]="'body'"
            //       (onChange)="changeRangoFechas()"
            //     ></p-dropdown>
            //   </div>
            // </div>

          
          // availableOptionsDay = [
          //   // {id : '0' , name: 'select'},
          //   { id: '1', name: 'Hoy' },
          //   { id: '2', name: 'Ayer' },
          //   { id: '3', name: 'hace 2 dias' },
          //   { id: '4', name: 'hace 3 dias' },
          //   { id: '5', name: 'Esta semana' },
          //   { id: '6', name: 'Semana pasada' },
          //   { id: '7', name: 'Este mes' },
          //   { id: '8', name: 'Mes pasado' },
          // ];

        

        };

        this.map.fitBounds([
          [minLat, minLng],
          [maxLat, maxLng],
        ], {padding: [30, 30]});



      });

    });


    this.temporizadorUbicacion = setInterval(() => {

      this.followLinkService.getLastTrama(this.config_seguimiento).subscribe(response => {
      
        console.log("===============  cada 5 segundos ?????  ");
        console.log(response);
        console.log(this.unidades);
        
        var result:any = response;
        var unidades:any = result.userTrackers;
        
        for (let j = 0; j < unidades.length; j++) {
          let index = this.unidades.findIndex(x => x.imei === unidades[j].imei);
          // console.log(index);
          if (index > -1) {

            this.unidades[index].latitud_anterior  = this.unidades[index].latitud ;
            this.unidades[index].longitud_anterior = this.unidades[index].longitud;
            //====================
            this.unidades[index].latitud  = parseFloat(unidades[j].latitud);
            this.unidades[index].longitud = parseFloat(unidades[j].longitud);
            this.unidades[index].velocidad = parseFloat(unidades[j].velocidad);
            this.unidades[index].fecha_tracker = unidades[j].fecha_tracker;

            this.unidades[index].icono.setLatLng([this.unidades[index].latitud, this.unidades[index].longitud]);
            this.unidades[index].icono.setPopupContent( this.getContentSimu(this.unidades[index]) );

            this.unidades[index].tooltip.setLatLng([this.unidades[index].latitud, this.unidades[index].longitud]);
            this.update_tooltip(this.unidades[index]); //actualiza contenido del tooltip

            let lat1 = this.unidades[index].latitud_anterior;
            let lon1 = this.unidades[index].longitud_anterior;
            let lat2 = this.unidades[index].latitud;
            let lon2 = this.unidades[index].longitud;

            let dist = this.calcularDistanciaEntreDosCoordenadas(lat1, lon1, lat2, lon2); // 0.01 Km
            // if ( dist >= 0.005 ) {
            if ( dist >= 0.005 ) {

              console.log("==================== NUEVO");
              console.log(this.unidades[index]);

              this.unidades[index].polyline_cola.addLatLng([this.unidades[index].latitud, this.unidades[index].longitud]);
              var m = this.unidades[index].polyline_cola.getLatLngs();
              this.unidades[index].polyline_cola_trace.setPaths(m);
              if (m.length > 5) {
                m.shift();
                this.unidades[index].polyline_cola.setLatLngs(m);
                this.unidades[index].polyline_cola_trace.setPaths(m);
              }   
              console.log(index+" - "+this.unidades[index].imei+" - "+this.unidades[index].velocidad);
              if ( this.unidades[index].icono._popup.isOpen() ) {
                this.getReference(this.unidades[index]);
              }
            } 
          }
        }
      });

        console.log("===============  cada 15 segundos ?????  ");
        // this.ogChangeReferences();
    }, 15000);

  }

  getParams(params: string) {
    var arrayParam = params.split('|'); // explode('|', params);
    var paramsObj = new Array();

    //var arrayParam = a[i].params.split("|");
    for (var j = 0; j < arrayParam.length; j++) {
      //======= ==============
      if (arrayParam[j].indexOf('=') > -1) {
        var temp = arrayParam[j].split('=');
        const v1 = temp[0].trim();
        const v2 = temp[1].trim();
        ////console.log(v1,v2);
        if (isNaN(parseFloat(v2))) {
          paramsObj.push({ id: v1, value: v2 });
        } else {
          paramsObj.push({ id: v1, value: parseFloat(v2) });
        }
      }
      //=======  ==============
      if (arrayParam[j].indexOf(':') > -1) {
        var temp = arrayParam[j].split(':');
        const v1 = temp[0].trim();
        const v2 = temp[1].trim();
        ////console.log(v1,v2);
        if (isNaN(parseFloat(v2))) {
          paramsObj.push({ id: v1, value: v2 });
        } else {
          paramsObj.push({ id: v1, value: parseFloat(v2) });
        }
      }
      ////console.log(paramsObj);
    }

    // //console.log("**** parametros ****");
    // //console.log(paramsObj);
    return paramsObj;
  }

  get_trama_marker(trama: any) {
    //============= LEGENDA

    // color: #FFF; -> BLANCO   sin señal
    // color: #000; -> NEGRO    con señal
    // color: #FF0; -> AMARILLO sin GPRS Status y diferencia entre fecha tracker y fecha de servidor  >= 180s  (3min)
    // color: #00E; -> AZUL     sin GPRS Status y diferencia entre fecha tracker y fecha de servidor  < 180s  (3min)
    // color: #0EE; -> TURQUESA ERROR

    let gprsStatus = trama.paramsGet.filter(
      (item: any) => item.id == 'GPRS Status'
    )[0];
    let color = '#0EE';
    if (gprsStatus == null) {
      let m_server = moment(new Date(trama.dt_server)); //new Date(trama.dt_server);
      let m_tracker = moment(new Date(trama.dt_tracker)); //new Date(trama.dt_tracker)
      let timeo = m_server.diff(m_tracker, 'seconds');
      ////console.log(timeo)
      if (timeo >= 180) {
        color = '#FF0';
      } else {
        color = '#00E';
      }
      //conParam = false;
    } else if (gprsStatus.value == 0) {
      color = '#FFF';
    } else if (gprsStatus.value == 1) {
      color = '#000';
    }

    var xlat = parseFloat(trama.lat).toFixed(6);
    var xlng = parseFloat(trama.lng).toFixed(6);
    var xdt_tracker = trama.dt_tracker.replace(/\//g, '-');

    var contenido =
      '<table class="dl-horizontal">' +
      '<tr><td>Posición</td><td>:<a href="https://maps.google.com/maps?q=' +
      trama.lat +
      ',' +
      trama.lng +
      '&amp;t=m" target="_blank">' +
      xlat +
      '°,' +
      xlng +
      '°</a></td></tr>' +
      '<tr><td>Altitud</td><td>:' +
      trama.altitude +
      ' m</td></tr>' +
      '<tr><td>Angulo</td><td>:' +
      trama.angle +
      '&#160;&#176;</td></tr>' +
      '<tr><td>Velocidad</td><td>:' +
      trama.speed +
      ' km/h</td></tr>' +
      '<tr><td>Tiempo</td><td>:' +
      xdt_tracker +
      ' </td></tr>' +
      '</table>';

    // var marker = L.marker([trama.lat, trama.lng],
    //       { icon: L.icon({
    //           iconUrl: feature,
    //           //iconSize:     [50, 45],
    //           iconAnchor:   [4.5, 4.5], //[16, 32],
    //           popupAnchor:  [0, 0]
    //       }),
    //       //clickable: true
    // }).bindPopup(contenido,{offset: new L.Point(0, -13)});

    var marker = L.circleMarker([trama.lat, trama.lng], {
      // pane: 'markers1',
      radius: 4,
      fillColor: color,
      fillOpacity: 1,
      color: '#000', //color,
      weight: 1,
      opacity: 1,
    }).bindPopup(contenido, { offset: new L.Point(0, -13) });
    // .bindTooltip(
    //   // "<div style='background:blue;'><b>" + this.geofences[i].zone_name+ "</b></div>",//,
    //   /* '<b class="" style="-webkit-text-stroke: 0.5px black; color: '+this.geopoints[i].geopunto_color+';">'+this.geopoints[i].geopunto_name+'</b>', */
    //   '<b class="" style=" background-color: '+ this.mapService.hexToRGBA('#F00') +'; color: '+ this.mapService.getContrastYIQ('#F00') +';">'+trama.dt_tracker+'<br>'+trama.speed+' km/h</b>',
    //   { permanent: true,
    //     offset: [20, 20],
    //     direction: 'center',
    //     className: 'leaflet-tooltip-own',
    //   });

    return marker;
  }
  
  get_trama_marker_fecha_velocidad(trama: any) {
    //============= LEGENDA
    let marker = L.circleMarker([trama.lat, trama.lng], {
      // pane: 'markers1',
      radius: 0,
      fillColor: '#000', //color,
      fillOpacity: 1,
      color: '#000', //color,
      weight: 1,
      opacity: 1,
    }).bindTooltip(
      // "<div style='background:blue;'><b>" + this.geofences[i].zone_name+ "</b></div>",//,
      /* '<b class="" style="-webkit-text-stroke: 0.5px black; color: '+this.geopoints[i].geopunto_color+';">'+this.geopoints[i].geopunto_name+'</b>', */
      '<b class="" style=" background-color: ' +
        this.mapService.hexToRGBA('#6633FF') +
        '; color: ' +
        this.mapService.getContrastYIQ('#6633FF') +
        ';">' +
        trama.dt_tracker +
        ' -> ' +
        trama.speed +
        ' km/h</b>',
      {
        permanent: true,
        offset: [20, 20],
        direction: 'center',
        className: 'leaflet-tooltip-own',
      }
    );

    return marker;
  }

  string_diffechas(a: any, b: any) {
    var c = Math.floor((b - a) / 1000) % 60;
    var d = Math.floor((b - a) / 60000) % 60;
    var e = Math.floor((b - a) / 3600000) % 24;
    var f = Math.floor((b - a) / 86400000);
    var g = '';
    if (f > 0) {
      g = '' + f + ' d ' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (e > 0) {
      g = '' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (d > 0) {
      g = '' + d + ' min ' + c + ' s';
    } else if (c >= 0) {
      g = '' + c + ' s';
    }
    return g;
  }

  get_combustible_movimiento(dH: any, a1: any, a2: any) {
    // console.log('==get_combustible_movimiento');
    // console.log(dH);
    // console.log(a1);
    // console.log(a2);

    // if (dH.length > 0) {
    //   console.log('== el imei');
    //   console.log(dH[0].imei);
    // }

    if (a2 == 'FIN') {
      var h = dH.length - 1; //Ultimo indice del array
      var x1 =
        dH[0].paramsGet.filter((item: any) => item.id == 'can_fuel_used')[0] ===
        undefined
          ? '-'
          : dH[0].paramsGet.filter((item: any) => item.id == 'can_fuel_used')[0]
              .value;
      var x2 =
        dH[h].paramsGet.filter((item: any) => item.id == 'can_fuel_used')[0] ===
        undefined
          ? '-'
          : dH[h].paramsGet.filter((item: any) => item.id == 'can_fuel_used')[0]
              .value;
      var kilometrajeTotal = '-';
      // console.log('======== 0 - Fin');
      // console.log(a1+' - '+a2);
      // console.log(x1+' - '+x2);
      // console.log(x2-x1);
      if (x1 == '-' || x2 == '-') {
        kilometrajeTotal = '-';

        // console.log("========= localStorage ========");
        // console.log(this.UserDataService.typeVehicles);
        // console.log(this.UserDataService.typeVehiclesUserData);
        // console.log(this.UserDataService.typeVehicles[0].var_galon);
        // console.log("=========");
        // console.log( this.cars );
        // console.log( this.VehicleService.getVehiclesData() );
        //let vehicles = this.VehicleService.getVehiclesData();

        // var tipoUnidad = this.VehicleService.getVehiclesData().filter(
        //   (item: any) => item.IMEI == dH[0].imei
        // )[0].tipo;
        // // console.log(tipoUnidad);
        // // console.log(parseInt(tipoUnidad));
        // var tipoU = this.UserDataService.typeVehiclesUserData.filter(
        //   (item: any) => item.type_vehicle_id == parseInt(tipoUnidad)
        // )[0];

        // console.log(tipoU);
        // console.log(tipoU.var_galon);
        // console.log(parseInt(tipoU.var_galon));
        var tipoU:any = undefined;
        if (tipoU === undefined || tipoU.var_galon == null) {
        // if (tipoU.var_galon == null) {
          kilometrajeTotal = '-.';
        } else {
          // galones x kilometros
          var distancia = this.get_distancia_movimiento(dH, a1, a2); // en km
          if (distancia == '-') {
            var distancia_nueva = 0;
            for (let i = 1; i < dH.length; i++) {
              if (dH[i].speed > 1) {
                distancia_nueva =
                  distancia_nueva +
                  this.calcularDistanciaEntreDosCoordenadas(
                    dH[i - 1].lat,
                    dH[i - 1].lng,
                    dH[i].lat,
                    dH[i].lng
                  );
              }
            }
            kilometrajeTotal =
              (distancia_nueva * parseInt(tipoU.var_galon)).toFixed(2) + 'gal.';
          } else {
            kilometrajeTotal =
              (parseFloat(distancia) * parseInt(tipoU.var_galon)).toFixed(2) +
              'gal.';
          }
        }

        // this.historialService.icono = (this.cars.filter((item:any)=> item.imei == dH[0].imei))[0].icon;
      } else {
        kilometrajeTotal =
          ((x2 - x1) * 0.2641).toFixed(2) +
          'gal. (' +
          (x2 - x1).toFixed(2) +
          'l.)';
      }
      return kilometrajeTotal;
    } else {
      var x1 =
        dH[a1].paramsGet.filter(
          (item: any) => item.id == 'can_fuel_used'
        )[0] === undefined
          ? '-'
          : dH[a1].paramsGet.filter(
              (item: any) => item.id == 'can_fuel_used'
            )[0].value;
      var x2 =
        dH[a2].paramsGet.filter(
          (item: any) => item.id == 'can_fuel_used'
        )[0] === undefined
          ? '-'
          : dH[a2].paramsGet.filter(
              (item: any) => item.id == 'can_fuel_used'
            )[0].value;
      var kilometrajeTotal = '-';
      if (x1 == '-' || x2 == '-') {
        kilometrajeTotal = '';

        console.log('================= XXX =================');

        // console.log(this.UserDataService.typeVehiclesUserData);
        // var tipoUnidad = this.VehicleService.getVehiclesData().filter(
        //   (item: any) => item.IMEI == dH[0].imei
        // )[0].tipo;
        // var tipoU = this.UserDataService.typeVehiclesUserData.filter(
        //   (item: any) => item.type_vehicle_id == parseInt(tipoUnidad)
        // )[0];

        // console.log(tipoUnidad + ' ================ ' + tipoU);
        if (tipoU === undefined || tipoU.var_galon == null) {
          kilometrajeTotal = '-.';
        } else {
          console.log(' ================ 111');

          var distancia = this.get_distancia_movimiento(dH, a1, a2); // en km
          console.log(' ================ 222');

          if (distancia == '-') {
            var distancia_nueva = 0;
            for (let i = a1 + 1; i <= a2; i++) {
              if (dH[i].speed > 1) {
                distancia_nueva =
                  distancia_nueva +
                  this.calcularDistanciaEntreDosCoordenadas(
                    dH[i - 1].lat,
                    dH[i - 1].lng,
                    dH[i].lat,
                    dH[i].lng
                  );
                console.log(' ================ ' + distancia_nueva);
              }
            }
            kilometrajeTotal =
              (distancia_nueva * parseInt(tipoU.var_galon)).toFixed(2) + 'gal.';
          } else {
            kilometrajeTotal =
              (parseFloat(distancia) * parseInt(tipoU.var_galon)).toFixed(2) +
              'gal.';
          }
        }
      } else {
        kilometrajeTotal =
          ((x2 - x1) * 0.2641).toFixed(2) +
          'gal. (' +
          (x2 - x1).toFixed(2) +
          'l.)';
      }
      return kilometrajeTotal;
    }
  }

  get_distancia_movimiento(dH: any, a1: any, a2: any) {
    // console.log("------- 11");
    if (a2 == 'FIN') {
      // console.log("------- 12 fin");
      var h = dH.length - 1; //Ultimo indice del array
      var x1 =
        dH[0].paramsGet.filter((item: any) => item.id == 'can_dist')[0] ===
        undefined
          ? '-'
          : dH[0].paramsGet.filter((item: any) => item.id == 'can_dist')[0]
              .value;
      var x2 =
        dH[h].paramsGet.filter((item: any) => item.id == 'can_dist')[0] ===
        undefined
          ? '-'
          : dH[h].paramsGet.filter((item: any) => item.id == 'can_dist')[0]
              .value;
      var kilometrajeTotal = '-';
      // console.log('======== 0 - Fin');
      // console.log(a1+' - '+a2);
      // console.log(x1+' - '+x2);
      // console.log(x2-x1);
      if (x1 == '-' || x2 == '-') {
        kilometrajeTotal = '-';

        var distancia_nueva = 0;
        for (let i = 1; i < dH.length; i++) {
          if (dH[i].speed > 1) {
            // console.log(dH[i - 1]);

            distancia_nueva =
              distancia_nueva +
              this.calcularDistanciaEntreDosCoordenadas(
                dH[i - 1].lat,
                dH[i - 1].lng,
                dH[i].lat,
                dH[i].lng
              );
          }
        }
        kilometrajeTotal = distancia_nueva.toFixed(2) + ' km';
      } else {
        kilometrajeTotal = (x2 - x1).toFixed(2) + ' km';
      }
      return kilometrajeTotal;
    } else {
      // console.log("------- 22 fin");

      var x1 =
        dH[a1].paramsGet.filter((item: any) => item.id == 'can_dist')[0] ===
        undefined
          ? '-'
          : dH[a1].paramsGet.filter((item: any) => item.id == 'can_dist')[0]
              .value;
      var x2 =
        dH[a2].paramsGet.filter((item: any) => item.id == 'can_dist')[0] ===
        undefined
          ? '-'
          : dH[a2].paramsGet.filter((item: any) => item.id == 'can_dist')[0]
              .value;
      var kilometrajeTotal = '-';
      if (x1 == '-' || x2 == '-') {
        kilometrajeTotal = '-';

        var distancia_nueva = 0;

        for (let i = a1 + 1; i <= a2; i++) {
          if (dH[i].speed > 1) {
            // console.log(a1);
            // console.log(a2);
            // console.log(dH);

            distancia_nueva =
              distancia_nueva +
              this.calcularDistanciaEntreDosCoordenadas(
                dH[i - 1].lat,
                dH[i - 1].lng,
                dH[i].lat,
                dH[i].lng
              );
          }
        }
        kilometrajeTotal = distancia_nueva.toFixed(2) + ' km';
      } else {
        kilometrajeTotal = (x2 - x1).toFixed(2) + 'km';
      }
      return kilometrajeTotal;
    }
  }

  get_inicial_marker(trama: any) {
    var xlat = parseFloat(trama.lat).toFixed(6);
    var xlng = parseFloat(trama.lng).toFixed(6);
    var xdt_tracker = trama.dt_tracker.replace(/\//g, '-');

    var contenido =
      '<table class="dl-horizontal">' +
      '<tr><td>Objeto</td><td>:</td><td>' +
      trama.nombre +
      '</td></tr>' +
      '<tr><td>Direcci&#243n</td><td>:</td><td><div id="direccionPopup"></div></td></tr>' +
      // '<tr><td>P.Cercano</td><td>: </td></tr>' +
      '<tr><td>Posición</td><td>:</td><td><a href="https://maps.google.com/maps?q=' +
      trama.lat +
      ',' +
      trama.lng +
      '&amp;t=m" target="_blank">' +
      xlat +
      '°,' +
      xlng +
      '°</a></td></tr>' +
      '<tr><td>Altitud</td><td>:</td><td>' +
      trama.altitude +
      'm</td></tr>' +
      '<tr><td>Angulo</td><td>:</td><td>' +
      trama.angle +
      '&#160;&#176;</td></tr>' +
      '<tr><td>Velocidad</td><td>:</td><td>' +
      trama.speed +
      'km/h</td></tr>' +
      '<tr><td>Tiempo</td><td>:</td><td>' +
      xdt_tracker +
      '</td></tr>' +
      '</table>';

    var marker = L.marker([trama.lat, trama.lng], {
      icon: L.icon({
        iconUrl: 'assets/images/route_start.png',
        iconAnchor: [16, 32],
      }),
      //clickable: true
    }).bindPopup(contenido, { offset: new L.Point(0, -13) });

    marker.on('click', (e:any) => {
        // console.log("================================>>>>>> marker.on(click ");
        // console.log(e);
        this.getReference(trama);
      });

    return marker;
  }
  
  get_final_marker(trama: any) {
    var xlat = parseFloat(trama.lat).toFixed(6);
    var xlng = parseFloat(trama.lng).toFixed(6);
    var xdt_tracker = trama.dt_tracker.replace(/\//g, '-');

    var contenido =
      '<table class="dl-horizontal">' +
      '<tr><td>Objeto</td><td>:</td><td>' +
      trama.nombre +
      '</td></tr>' +
      '<tr><td>Direcci&#243n</td><td>:</td><td><div id="direccionPopup"></div></td></tr>' +
      // '<tr><td>P.Cercano</td><td>: </td></tr>' +
      '<tr><td>Posición</td><td>:</td><td><a href="https://maps.google.com/maps?q=' +
      trama.lat +
      ',' +
      trama.lng +
      '&amp;t=m" target="_blank">' +
      xlat +
      '°,' +
      xlng +
      '°</a></td></tr>' +
      '<tr><td>Altitud</td><td>:</td><td>' +
      trama.altitude +
      'm</td></tr>' +
      '<tr><td>Angulo</td><td>:</td><td>' +
      trama.angle +
      '&#160;&#176;</td></tr>' +
      '<tr><td>Velocidad</td><td>:</td><td>' +
      trama.speed +
      'km/h</td></tr>' +
      '<tr><td>Tiempo</td><td>:</td><td>' +
      xdt_tracker +
      '</td></tr>' +
      '</table>';

    var marker = L.marker([trama.lat, trama.lng], {
      icon: L.icon({
        iconUrl: 'assets/images/route_end.png',
        iconAnchor: [16, 32],
      }),
      //clickable: true
    }).bindPopup(contenido, { offset: new L.Point(0, -13) });

    marker.on('click', (e:any) => {
      this.getReference(trama);
    });

    return marker;
  }

  get_historial_line(path: any, color: string) {
    var opciones = {
      color: color,
      weight: 3,
      opacity: 1.0,
    };
    var linea = L.polyline(path, opciones);
    return linea;
  }

  mostrar_tabla2(dH: any, iH: any, idx: any = -1) {
    console.log('==== mostrar_tabla2 ===>>');
    //if (this.conHistorial) {
    if (this.followLinkService.arrayRecorridos.length > 0) {
      this.transfers = [];
      this.transfers.push({
        icono: 'assets/images/route_start.png',
        tooltip: 'Inicio',
        trama: dH[0],
        icono_width: '13px',
        icono_height: '13px',
        dt_tracker: dH[0].dt_tracker,
        index_master: idx,
      });

      for (let i = 0; i < iH.length; i++) {
        //===== obtener la distacia con en can
        if (dH[iH[i]].marker == 'PARADA') {
          // if (this.form.chckParada) {
          if (true) {
            this.transfers.push({
              icono: 'assets/images/stop.svg',
              tooltip: 'Parada',
              trama: dH[iH[i]],
              icono_width: '11px',
              icono_height: '13px',
              dt_tracker: dH[iH[i]].dt_tracker,
              index_master: idx,
            });
          }
        } else {
          // var x1 = (dH[iH[i]].paramsGet.filter((item:any)=> item.id == "can_dist"))[0] === undefined ? "-" : (dH[iH[i]].paramsGet.filter((item:any)=> item.id == "can_dist"))[0].value;
          // console.log('movimi = '+iH[i]+' - '+x1);
          // console.log(dH[iH[i]]);
          this.transfers.push({
            icono: 'assets/images/drive.svg',
            tooltip: 'Movimiento',
            trama: dH[iH[i]],
            icono_width: '13px',
            icono_height: '13px',
            dt_tracker: dH[iH[i]].dt_tracker,
            index_master: idx,
          });
        }
      }
      // console.log(this.eventList);
      // console.log(this.EventService.eventsHistorial);
      var EventosAll = [];


      console.log('=======================================');
      console.log("VER DATOS DE AQUI GENERALES DE LA ROW PRINCIPAL ",this.followLinkService.arrayRecorridos);
      console.log(idx);
      console.log("VER DATOS DE LAS ROW DEBAJO DEL PRINCIPAL ", this.followLinkService.arrayRecorridos[idx]);

      EventosAll = this.followLinkService.arrayRecorridos[idx].eventos;

      
      console.log("LOS EVENTOS", EventosAll);

      for (let index = 0; index < EventosAll.length; index++) {
        const item = EventosAll[index];
/*         var activar = false;
        if (this.chkAllEvents) {
          activar = true;
        } else {
          for (let j = 0; j < this.selectedEvents.length; j++) {
            const opEve = this.selectedEvents[j];
            //console.log(EventosAll[index].tipo+" -  "+opEve.value);
            if (EventosAll[index].evento == opEve.value) {
              //console.log("SII APARECE");
              var activar = true; // false;
            }
          }
        } */

        /* if ( activar ) { */
        if ( true ) {
          item.lat = parseFloat(item.latitud);
          item.lng = parseFloat(item.longitud);
          item.dt_tracker = item.fecha_tracker.replace(/\//g, '-');
          this.transfers.push({
            icono: item.layer.options.icon.options.iconUrl,
            tooltip: item.nombre,
            trama: item,
            icono_width: '17px',
            icono_height: '18px',
            dt_tracker: item.dt_tracker,
            index_master: idx,
          });

       /*    if (this.followLinkService.arrayRecorridos[idx].mostrarRuta) {
            item.layer.addTo(this.mapService.map); //.openPopup();
          } */
        } else {
          this.mapService.map.removeLayer(item.layer);
        }
        // console.log("LAYER", item.layer.options.icon.options.iconUrl,)
      } // fin del for

      this.transfers = this.sortByKey(this.transfers, 'dt_tracker');

      dH[dH.length - 1].distancia = '- km';
      this.transfers.push({
        icono: 'assets/images/end.png',
        tooltip: 'Fin',
        trama: dH[dH.length - 1],
        icono_width: '13px',
        icono_height: '13px',
        dt_tracker: dH[dH.length - 1].dt_tracker,
        index_master: idx,
      });

      this.followLinkService.arrayRecorridos[idx].tramas = this.transfers;

      // if (idx == -1) {
      //   if (this.conHistorial && this.transfers.length > 0) {
      //     console.log(
      //       'LLENAR TRAMAS ================================================ - ' +
      //         idx
      //     );
      //     this.historialService.arrayRecorridos[
      //       this.historialService.arrayRecorridos.length - 1
      //     ].tramas = this.transfers;
      //   }
      // } else {
      //   if (this.conHistorial && this.transfers.length > 0) {
      //     console.log(
      //       'LLENAR TRAMAS ================================================ - ' +
      //         idx
      //     );
      //     this.historialService.arrayRecorridos[idx].tramas = this.transfers;
      //   }
      // }
    }
  }

  sortByKey(array: any, key: any) {
    return array.sort((a: any, b: any) => {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }


  changeShowingTramas() {
    // if (this.conHistorial) {
    //   var dH =  this.historialService.tramasHistorial; // Data Historial
    //   if (this.form.chckTrama) {
    //     for (let i = 0; i < dH.length; i++) {
    //       dH[i]._trama.addTo(this.mapService.map);
    //     }
    //   } else {
    //     for (let i = 0; i < dH.length; i++) {
    //       this.mapService.map.removeLayer(dH[i]._trama);
    //     }
    //   }
    // }

    //=================================================================================

    // this.followLinkService.dataFormulario.chckTrama = this.form.chckTrama;

    console.log(this.mapService.map.getZoom());

    var lvlzoom = this.mapService.map.getZoom();
    var nivel = 1000; // todo
    var ccont = 0;
    switch (lvlzoom) {
      case 12:
        nivel = 1000; //todo
        console.log('-------12 - 1000');
        break;
      case 13:
        nivel = 600; //todo
        console.log('-------13 - 600');
        break;
      case 14:
        nivel = 400; //todo
        console.log('-------14 - 400');
        break;
      case 15:
        nivel = 300; //todo
        console.log('-------15 - 200');
        break;
      case 16:
        nivel = 200; //todo
        console.log('-------16 - 100');
        break;
      case 17:
        nivel = 100; //todo
        console.log('-------17 - 50');
        break;
      case 18:
        nivel = 1; //todo
        console.log('-------18 - 1');
        break;
      default:
        nivel = 1000; // todo
        console.log('-------default');
        break;
    }

    var acum1 = 0.0;
    var acum2 = nivel;

    if (lvlzoom >= 12) {
      var allH = this.followLinkService.arrayRecorridos;

      for (let j = 0; j < allH.length; j++) {
        var dH = allH[j].recorrido;
        var mostrarR = allH[j].mostrarRuta;

        for (let i = 0; i < dH.length; i++) {
          this.mapService.map.removeLayer(dH[i]._trama);
          this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
          // this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
        }

        if (this.form.chckTrama && mostrarR) {
          for (let i = 0; i < dH.length; i++) {
            dH[i]._trama.addTo(this.mapService.map);

            // acum1 = acum1 + dH[i].distancia;
            // // if (dH[i].distancia > nivel) {
            // if (acum1 > acum2) {
            //   acum2 = acum2 + nivel;
            //   // if (ccont == i) {
            //   // console.log(ccont);
            //   dH[i]._trama.addTo(this.mapService.map);
            //   //   ccont = ccont + nivel;
            //   // }
            // }
          }
        }
      }
    }
  }

  decoradorMASTER(a:any) {
        // Función para animar las flechas
        let currentOffset = 0;
        function animateArrows() {
          currentOffset += 0.2;
          if (currentOffset > 35) {
            currentOffset = 0;
          }

          // Actualiza el offset de la flecha
          a.polyline_cola_trace.setPatterns([
            {
              offset: currentOffset,
              repeat: 35,
              symbol: L.Symbol.arrowHead({
              pixelSize: 10,
              polygon: true,
              pathOptions: {
                stroke: true,
                weight: 1,

                color: '#00d425',
                opacity: 1,

                fillColor: 'white',
                fillOpacity : 1,
              },
            }),
            },
          ]);

          requestAnimationFrame(animateArrows);
        }
        animateArrows();
        // requestAnimationFrame(animateArrows);
  }

  ubicar_unidad() {
    
    let index = this.unidades.findIndex(x => x.imei === this.unidadSeleccionada);
    // console.log(index);
    if (index > -1) {
      this.mapService.map.setView([this.unidades[index].latitud, this.unidades[index].longitud]);
    }

  }


  getContentSimu(item:any) {

    const googleMapsLink = `https://www.google.com/maps?q=${item.latitud},${item.longitud}`;

    var newContent = '<div class="row" style="width:250px;"><div class="col-6" align="left"><strong>' +
    item.nombre +
    '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
    item.velocidad +
    ' km/h</strong></div></div>' +
    '<aside class="">' +
    // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor"><i class="fas fa-user-circle"></i></span> ' +
    // item.namedriver +
    // '</small><br>' +
    '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Ubicacion"><i class="fas fa-crosshairs"></i></span><a href=" ' +
    googleMapsLink +
    '" target="_blank">' +
    item.latitud.toFixed(6) +
    ', ' +
    item.longitud.toFixed(6) +
    '</a></small><br>' +
    `<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Referencia"><i class="fas fa-map-marked-alt"></i></span> <span id="direccionPopup" >Calculando...</span>` +
    // item.ref +
    '</small><br>' +
    '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Fecha de Transmision"><i class="fas fa-calendar-alt"></i></span> ' +
    item.fecha_tracker +
    '</small><br>' +
    // '<small><span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Tiempo de Parada"><i class="fas fa-hourglass-half"></i></span> ' +
    // item.tiempoParada +
    // '</small><br>' +
    '<!-- <button class="btn-open-modal btn-history">' + 'Abrir Historial' + '</button> -->' +
    '</aside>';

    return newContent;


    // '<tr><td>Direcci&#243n</td><td>:</td><td><div id="direccionPopup"></div></td></tr>' +



    // var xdt_tracker= 'XXXXX';//item.dt_tracker.replace(/\//g, "-");
  
    // return (
    //   `<table class="dl-horizontal">
    //     <tr><td><b> ${ xdt_tracker } </b></td><td> &#160;(${item.velocidad} km/h)</td></tr>
    //   </table>`
    // );
  }

  
  get_tooltip(trama: any) {
    //============= LEGENDA
    let marker = L.circleMarker([trama.latitud, trama.longitud], {
      // pane: 'markers1',
      radius: 0,
      fillColor: '#000', //color,
      fillOpacity: 1,
      color: '#000', //color,
      weight: 1,
      opacity: 1,
    }).bindTooltip(
      // "<div style='background:blue;'><b>" + this.geofences[i].zone_name+ "</b></div>",//,
      /* '<b class="" style="-webkit-text-stroke: 0.5px black; color: '+this.geopoints[i].geopunto_color+';">'+this.geopoints[i].geopunto_name+'</b>', */
          '<b class="" style=" background-color:'+this.mapService.hexToRGBA('#FFF')+'; color:'+this.mapService.hexToRGBA('#3f3844')+';">' + 

          '<span id="tooltip'+trama.imei+'">' + trama.nombre+'</span>' +
          //'<span id="tooltip'+trama.imei+'">' + trama.nombre+' -> '+trama.velocidad +' km/h'+'</span>' +

          '</b>',
      {
        permanent: true,
        offset: [0, 40],
        direction: 'center',
        className: 'leaflet-css-follow',
      }
    );

    return marker;
  }

  update_tooltip(trama: any) {
    //============= LEGENDA
    // console.log("_________update_tooltip");
    var txt_tooltip = trama.nombre;
    // var txt_tooltip = trama.nombre+' -> '+trama.velocidad;
    $("#tooltip"+trama.imei).text(txt_tooltip);

  }

  // this.markerClusterGroup.getLayers()[key]['_popup'].setContent(newContent);

  get_parada_marker(trama: any) {
    // new map.Parada([dH[item].lat, dH[item].lng], { icon: new L.Icon(icon), showTrace: true })
    // .bindPopup(historialHelper.getContentPopup(dH[item]), {offset: new L.Point(0, -13)} );
    trama.latitud = parseFloat(trama.lat);
    trama.longitud = parseFloat(trama.lng);
    var xlat = parseFloat(trama.lat).toFixed(6);
    var xlng = parseFloat(trama.lng).toFixed(6);
    var xdt_tracker = trama.dt_tracker.replace(/\//g, '-');
    var xparadaFin = trama.paradaFin.replace(/\//g, '-');

    // return (
    var contenido =
      '<table class="dl-horizontal">' +
      '<tr><td width="57px">Parada</td><td>:</td><td width="140px">' +
      trama.count +
      '</td></tr>' +
      '<tr><td>Objeto</td><td>:</td><td>' + trama.nombre +'</td></tr>' +
      '<tr><td>Direcci&#243n</td><td>:</td><td><div id="direccionPopup">...</div></td></tr>' +
      // '<tr><td>P.Cercano</td><td>: </td></tr>' +
      '<tr><td>Posición</td><td>:</td><td><a href="https://maps.google.com/maps?q=' +
      trama.lat +
      ',' +
      trama.lng +
      '&amp;t=m" target="_blank">' +
      xlat +
      '°,' +
      xlng +
      '°</a></td></tr>' +
      '<tr><td>Altitud</td><td>:</td><td>' +
      trama.altitude +
      'm</td></tr>' +
      '<tr><td>Angulo</td><td>:</td><td>' +
      trama.angle +
      '&#160;&#176;</td></tr>' +
      '<tr><td>Tiempo</td><td>:</td><td>' +
      xdt_tracker +
      '</td></tr>' +
      '<tr><td>Restante</td><td>:</td><td>' +
      xparadaFin +
      '</td></tr>' +
      '<tr><td>Duraci&#243n</td><td>:</td><td>' +
      trama.temp +
      '</td></tr>' +
      '</table>';
    // );

    var marker = L.marker([trama.lat, trama.lng], {
      icon: L.icon({
        iconUrl: 'assets/images/stop.svg',
        iconAnchor: [26, 26],
      }),
      //clickable: true
    }).bindPopup(contenido, { offset: new L.Point(0, -13) });

    marker.on('click', (e:any) => {
      this.getReference(trama);
    });

    return marker;
  }



  async createMap() {
    console.log('CREATE MAPPPPPPPPPP');

    const parcThabor = {
      lat: -11.107323,
      lng: -75.523437,
    };

    const zoomLevel = 7;

    // this.followLinkService.map = L.map(this.container, {
    this.followLinkService.map = L.map('mapId01', {

      preferCanvas: true,
      renderer: L.canvas(),
      center: [parcThabor.lat, parcThabor.lng],
      zoom: zoomLevel,
      maxZoom: 19,
      editable: true,
    });

    // if(mainLayer.addTo(this.map)){
    this.followLinkService.loadMap(this.followLinkService.map);
    // }

    //this.mapServicesService.map.on('zoomstart zoom zoomend moveend', (ev) => {
    this.followLinkService.map.on('moveend', (ev) => {
      // gauge.innerHTML = `Zoom level: ${map.getZoom()}`;
      // console.log("--------------------------------------");

      // console.log(this.mapServicesService.map.getZoom());
      // console.log(this.historialService.arrayRecorridos);

      //========================================================
      // console.log(this.mapService.map.getZoom());
      console.log(this.followLinkService.map.getZoom(), ev);

      var lvlzoom = this.followLinkService.map.getZoom();
      var nivel = 1000; // todo
      var ccont = 0;
      switch (lvlzoom) {
        case 12:
          nivel = 1000; //todo
          console.log('-------12 - 1000');
          break;
        case 13:
          nivel = 600; //todo
          console.log('-------13 - 600');
          break;
        case 14:
          nivel = 400; //todo
          console.log('-------14 - 400');
          break;
        case 15:
          nivel = 300; //todo
          console.log('-------15 - 200');
          break;
        case 16:
          nivel = 200; //todo
          console.log('-------16 - 100');
          break;
        case 17:
          nivel = 100; //todo
          console.log('-------17 - 50');
          break;
        case 18:
          nivel = 1; //todo
          console.log('-----a--18 - 1');
          break;
        default:
          nivel = 1000; // todo
          console.log('-------default');
          break;
      }

      var acum1 = 0.0;
      var acum2 = nivel;




    //   var chckTrama = this.historialService.dataFormulario.chckTrama;
    //   var chckTramaFechaVelocidad =
    //     this.historialService.dataFormulario.chckTramaFechaVelocidad;

    //   console.log('check trama = ' + chckTrama);

    //   var allH = this.historialService.arrayRecorridos;
    //   for (let j = 0; j < allH.length; j++) {
    //     var dH = allH[j].recorrido;
    //     var mostrarR = allH[j].mostrarRuta;

    //     for (let i = 0; i < dH.length; i++) {
    //       this.mapService.map.removeLayer(dH[i]._trama);
    //       this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
    //     }

    //     if (lvlzoom >= 12) {
    //       if (chckTrama && mostrarR) {
    //         for (let i = 0; i < dH.length; i++) {
    //           if (isNaN(parseFloat(dH[i].distancia))) {
    //             // console.log("----------DAA---------");
    //           } else {
    //             acum1 = acum1 + parseFloat(dH[i].distancia);
    //             // console.log(acum1 +"  -  "+acum2+"  -  "+parseFloat(dH[i].distancia));
    //           }
    //           dH[i]._trama.addTo(this.mapService.map);
    //           if (acum1 > acum2) {
    //             acum1 = 0;
    //             // console.log(acum1 +"  -  "+ acum2);
    //             if (chckTramaFechaVelocidad) {
    //               if (
    //                 this.mapService.map
    //                   .getBounds()
    //                   .contains(dH[i]._trama.getLatLng())
    //               ) {
    //                 dH[i]._trama_fecha_velocidad.addTo(this.mapService.map);
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    
    });

    this.followLinkService.map.on('baselayerchange', (ev:any) => {
      // console.log(ev);
      // console.log(ev.name);
      if (ev.name == "OpenStreetMap") {
        this.followLinkService.map.setMaxZoom(19);
      } else if(ev.name == "Google Terrain") {
        this.followLinkService.map.setMaxZoom(21);
      } else if(ev.name == "Google Hybrid") {
        this.followLinkService.map.setMaxZoom(21);
      } else if(ev.name == "Google Streets") {
        this.followLinkService.map.setMaxZoom(21);
      } else if(ev.name == "Google Satellite") {
        this.followLinkService.map.setMaxZoom(21);
      }
    });
    
  }

  changeShowingTramasFechaVelocidad() {
    // // : marker.bindTooltip(tooltipText, {permanent:false} )
    // if (this.conHistorial) {
    //   var dH =  this.historialService.tramasHistorial; // Data Historial

    //   if (this.form.chckTrama) {
    //     if (this.form.chckTramaFechaVelocidad) {
    //         for (let i = 0; i < dH.length; i++) {
    //           dH[i]._trama_fecha_velocidad.addTo(this.mapService.map);
    //           // dH[i]._trama.bindTooltip( "gaaaaaaa1",{permanent:true})
    //         }
    //     } else {
    //         for (let i = 0; i < dH.length; i++) {
    //           this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
    //           // dH[i]._trama.bindTooltip("gaaaaaaa2",{permanent:false})
    //         }
    //     }
    //   } else {
    //     for (let i = 0; i < dH.length; i++) {
    //       this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
    //       // dH[i]._trama.bindTooltip("gaaaaaaa3",{permanent:false})
    //     }
    //   }
    // }

    ///==============================================================

    // this.historialService.dataFormulario.chckTramaFechaVelocidad =
    //   this.form.chckTramaFechaVelocidad;

    // console.log(this.mapService.map.getZoom());

    var lvlzoom = this.mapService.map.getZoom();
    var nivel = 100; // todo
    var ccont = 0;
    switch (lvlzoom) {
      case 12:
        nivel = 1000; //todo
        console.log('-------12 - 1000');
        break;
      case 13:
        nivel = 600; //todo
        console.log('-------13 - 600');
        break;
      case 14:
        nivel = 400; //todo
        console.log('-------14 - 400');
        break;
      case 15:
        nivel = 300; //todo
        console.log('-------15 - 200');
        break;
      case 16:
        nivel = 200; //todo
        console.log('-------16 - 100');
        break;
      case 17:
        nivel = 100; //todo
        console.log('-------17 - 50');
        break;
      case 18:
        nivel = 1; //todo
        console.log('-------18 - 1');
        break;
      default:
        nivel = 1000; // todo
        console.log('-------default');
        break;
    }

    var acum1 = 0.0;
    var acum2 = nivel;

    //movimiento
    //https://stackoverflow.com/questions/35800775/leaflet-js-fire-event-when-map-pans
    if (lvlzoom >= 12) {
      var allH = this.followLinkService.arrayRecorridos;
      for (let j = 0; j < allH.length; j++) {
        var dH = allH[j].recorrido;
        var mostrarR = allH[j].mostrarRuta;

        for (let i = 0; i < dH.length; i++) {
          // this.mapService.map.removeLayer(dH[i]._trama);
          this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
        }

        if (this.form.chckTramaFechaVelocidad && mostrarR) {
          for (let i = 0; i < dH.length; i++) {
            if (isNaN(parseFloat(dH[i].distancia))) {
              // console.log("----------DAA---------");
            } else {
              acum1 = acum1 + parseFloat(dH[i].distancia);
              // console.log(acum1 +"  -  "+acum2+"  -  "+parseFloat(dH[i].distancia));
            }

            if (acum1 > acum2) {
              acum1 = 0;
              // console.log(acum1 +"  -  "+ acum2);
              if (
                this.mapService.map
                  .getBounds()
                  .contains(dH[i]._trama.getLatLng())
              ) {
                dH[i]._trama_fecha_velocidad.addTo(this.mapService.map);
              }
            }
          }
        }
      }
    }
  }


  async getReference(trama:any) {
    console.log('------ getReference ');

    let reference = await this.followLinkService.getReference(trama.latitud, trama.longitud);
    var referencia = reference.referencia;
    $("#direccionPopup").text(referencia);

    // this.historialService.direccionPopup = referencia;
    // console.log('-------------------------');
    // console.log( this.historialService.direccionPopup );
    // $("#direccionPopup").html(this.historialService.direccionPopup );

    // console.log(referencia);
    // this.sliderValueReferencia = referencia;
    // return referencia;
  }

  async getReferencePanel(trama:any) {
    console.log('------ getReferencePanel ');

    let reference = await this.followLinkService.getReference(trama.latitud, trama.longitud);
    var referencia = reference.referencia;
    this.localizacionPanel = referencia;
  }


  // Resultado en KM ==> E.  0.5233045500808429  = 0.52 Kilómetros
  calcularDistanciaEntreDosCoordenadas(
    lat1: any,
    lon1: any,
    lat2: any,
    lon2: any
  ) {
    // Convertir todas las coordenadas a radianes
    lat1 = this.gradosARadianes(lat1);
    lon1 = this.gradosARadianes(lon1);
    lat2 = this.gradosARadianes(lat2);
    lon2 = this.gradosARadianes(lon2);
    // Aplicar fórmula
    const RADIO_TIERRA_EN_KILOMETROS = 6371;
    let diferenciaEntreLongitudes = lon2 - lon1;
    let diferenciaEntreLatitudes = lat2 - lat1;
    let a =
      Math.pow(Math.sin(diferenciaEntreLatitudes / 2.0), 2) +
      Math.cos(lat1) *
        Math.cos(lat2) *
        Math.pow(Math.sin(diferenciaEntreLongitudes / 2.0), 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return RADIO_TIERRA_EN_KILOMETROS * c;
  }

  gradosARadianes(grados: any) {
    return (grados * Math.PI) / 180;
  }


  onChkMostrarRuta(key: any) {
    console.log('-----------------onChkMostrarRuta');
    console.log();

    this.followLinkService.arrayRecorridos[key];

    console.log(this.followLinkService.arrayRecorridos[key]);
    console.log(this.followLinkService.arrayRecorridos);

    var dH = this.followLinkService.arrayRecorridos[key].recorrido;
    var iH = dH[0].index_historial; //indices de paradas y movimientos

    // if (this.conHistorial) {
    //   this.mostrar_tabla(dH, dH[0].index_historial);
    // }

    if (this.followLinkService.arrayRecorridos[key].mostrarRuta) {
      for (let i = 0; i < iH.length; i++) {
        if (dH[iH[i]].marker == 'PARADA') {
          // if (this.form.chckParada) {
          if (true) {
            dH[iH[i]].layer.addTo(this.mapService.map);
          }
        }
      }

      // if (this.form.chckTrama) {
      //   for (let i = 0; i < dH.length; i++) {
      //     dH[i]._trama.addTo(this.mapService.map);
      //   }
      // }


      // if (this.form.chckTramaFechaVelocidad) {
      //   for (let i = 0; i < dH.length; i++) {
      //     dH[i]._trama_fecha_velocidad.addTo(this.mapService.map);
      //   }
      // }

      //eventos
      console.log('=======================================');
      // console.log(this.historialService.arrayRecorridos);
      // console.log(idx);
      // console.log(this.historialService.arrayRecorridos[idx]);

      var EventosAll = this.followLinkService.arrayRecorridos[key].eventos;

      for (let index = 0; index < EventosAll.length; index++) {
        EventosAll[index].layer.addTo(this.mapService.map);
      }

      dH[0].layer0.addTo(this.mapService.map);
      dH[dH.length - 1].layerN.addTo(this.mapService.map);

      dH[0].rutaH2.addTo(this.mapService.map); // = this.get_historial_line( dH[0].rutaH , color).addTo(this.mapService.map); //Linea del historial
      dH[0].ruta_sub.addTo(this.mapService.map); // = this.get_historial_line( [] , color_sub).addTo(this.mapService.map); //Sub linea del historial
      dH[0].rutaH2_trace.addTo(this.mapService.map);
    } else {
      for (let i = 0; i < dH.length; i++) {
        if (dH[i].layer != null) {
          this.mapService.map.removeLayer(dH[i].layer);
        }
      }

  
      // for (let i = 0; i < dH.length; i++) {
      //   this.mapService.map.removeLayer(dH[i]._trama);
      //   this.mapService.map.removeLayer(dH[i]._trama_fecha_velocidad);
      // }


      this.mapService.map.removeLayer(dH[0].layer0);
      this.mapService.map.removeLayer(dH[dH.length - 1].layerN);

      this.mapService.map.removeLayer(dH[0].rutaH2);
      this.mapService.map.removeLayer(dH[0].ruta_sub);
      this.mapService.map.removeLayer(dH[0].rutaH2_trace);
    }

    var eH = this.followLinkService.arrayRecorridos[key].eventos;

    if (this.followLinkService.arrayRecorridos[key].mostrarRuta) {
      this.mostrar_tabla2(dH, iH, key);
    } else {
      for (let i = 0; i < eH.length; i++) {
        this.mapService.map.removeLayer(eH[i].layer);
      }
    }
  }

  //======eventos

    addMultimediaComponent(event: any) {
      if (
        event.parametros &&
        event.parametros.gps == 'cipia' &&
        (event.parametros.has_video != '0' || event.parametros.has_image != '0')
      ) {
        console.log('adding multimedia: ', event);
  
        const factory = this.resolver.resolveComponentFactory(
          SliderMultimediaComponent
        );
        const componentRef: ComponentRef<any> =
          this.container.createComponent(factory);
        const params: any = {
          event: event!,
          driver:
            this.VehicleService.vehicles.find((vh) => vh.IMEI == event.imei)
              ?.namedriver ?? '',
          showMultimediaFirst: true,
          hasMultimedia: true,
          showTitle: false,
          showFooter: false,
        };
        console.log('eventRowSelected panel historial');
        // Asignar datos al componente si existen
  
        Object.keys(params).forEach((key) => {
          componentRef.instance[key] = params[key];
        });
        // Agregar el componente directamente al contenedor del popup
        console.log(
          'componentRef.location.nativeElement',
          componentRef.location.nativeElement
        );
  
        const divContainer = document.getElementById(
          'multimedia-' + event.uuid_event
        )!;
        divContainer.innerHTML = '';
        console.log('divContainer', divContainer);
        divContainer.appendChild(componentRef.location.nativeElement);
      }
    }
    addDVRGalleryComponent(event: any) {
        try {
          const factory = this.resolver.resolveComponentFactory(
            DvrGalleryComponent!
          );
          const componentRef = this.container.createComponent(factory);
          componentRef.instance.event = event;
          const container = document.getElementById(
            'dvrgallery-' + event.uuid_event
          )!;
          container.innerHTML = '';
          container.appendChild(componentRef.location.nativeElement);
          componentRef.changeDetectorRef.detectChanges();
          // this.appRef.tick();
        } catch (error) {
          console.log('Saint', error);
        }
      }
  
    clearMultimedia(event: any) {
      if (this.EventService.activeEvent) {
        if (
          this.EventService.activeEvent.id == event.id &&
          event.layer.isPopupOpen()
        ) {
          console.log('no hacer nada');
          return;
        }
        this.EventService.activeEvent.layer.closePopup();
        this.EventService.activeEvent.layer.unbindPopup();
        this.EventService.activeEvent.layer.off();
        this.mapService.map.removeLayer(event.layer);
        this.EventService.activeEvent = false;
      }
    }

}
